module.exports = __webpack_public_path__ + "img/default_avatar.d1cc4d65.png";